import { createSlice } from '@reduxjs/toolkit';
import { Screen } from 'constants/tracking/screens';
import { stateName } from './constants';
export const initialState = {
  name: Screen.Unknown
};

const setName = (draft, action) => {
  const {
    name
  } = action.payload;
  draft.name = name;
};

const screenSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    setName
  }
});
export const {
  actions
} = screenSlice;
export const plug = {
  [stateName]: screenSlice.reducer
};
export default screenSlice.reducer;